import React, {useState} from "react";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import SearchTable from "../../../primer/Search-Table";

const SearchDrugs = () => {
    const searchFilters = {
        filters: [
            {
                name: "general",
                label: "Φίλτρο barcode/εμπορικής ονομασίας",
                type: "input",
            },
            {
                name: "producer",
                label: "Κατασκευαστής",
                type: "input",
            },
            {
                name: "activeSubstance",
                label: "Δραστική Ουσία",
                type: "input",
            },
            {
                name: "special",
                label: "Χαρακτηριστικά Φαρμάκου",
                type: "multiselect",
                options: [
                    {value: "shortage", label: "Σε έλλειψη"},
                    {value: "ifet", label: "Ι.Φ.Ε.Τ."},
                    {value: "drug", label: "Ναρκωτικό"},
                    {value: "nonPrescriptable", label: "Μη συνταγογραφούμενο"},
                    {value: "notInCirculation", label: "Εκτός κυκλοφορίας"},
                    {value: "withdrawn", label: "Αποσυρμένο"},
                    {value: "positiveList", label: "Θετικής Λίστας"},
                    {value: "negativeList", label: "Αρνητικής Λίστας"}
                ]
            }
        ],
        actions: [],
    }

    const searchColumns = [
        {
            name: "Barcode",
            field: "barcode",
            editable: false,
            width: "15%",
            inputType: {
                type: "text",
            }
        },
        {
            name: "Εμπορική Ονομασία",
            field: "commercialName",
            editable: false,
            width: "15%",
            inputType: {
                type: "text",
            }
        },
        {
            name: "Κύρια δραστική ουσία",
            field: "erp_main_active_substance",
            editable: false,
            width: "25%",
            inputType: {
                type: "text",
            }
        },
        {
            name: "Κατασκευαστής",
            field: "producer",
            editable: false,
            width: "25%",
            inputType: {
                type: "text",
            }
        },
        {
            name: "Μονάδα δόσης",
            field: "doseUnit",
            editable: false,
            width: "10%",
            inputType: {
                type: "text",
            }
        },
        {
            name: "Τιμή λιανικής",
            field: "retailPrice",
            editable: false,
            width: "10%",
            inputType: {
                type: "text",
            }
        }
    ]

    const [tableColumns, setTableColumns] = useState(searchColumns.slice());

    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
        <div>
            <SearchTable
                tableName={"Prescription Search Drugs"}
                key={"Prescription Search Drugs"}
                hideYearFilter={true}
                allowPagination={true}
                allowToggleColumns={true}
                showDummyData={false}
                columns={tableColumns}
                toggleColumns={handleColumnShowHide}
                allowSelectionCheckbox={false}
                data={[]}
                filtersConfig={searchFilters}
                allowSorting={false}
            />
        </div>
    )
}

export default SearchDrugs
